export enum billingMethods {
  ACCOUNT_BILLED = 'Account Billed',
  AUTOMATIC_PAYMENT_PLAN = 'Automatic Payment Plan',
  AUTOMATIC_PAYMENT_PLAN_BANK_ACCOUNT = 'Automatic Payment Plan - Bank Account',
  AUTOMATIC_PAYMENT_PLAN_CREDIT_CARD = 'Automatic Payment Plan - Credit Card',
  BILLED_TO_MORTGAGEE = 'Billed to Mortgagee',
  DIRECTLY_BILLED = 'Directly Billed',
  LIST_BILLED = 'List Billed',
  PAYROLL_OR_PENSION_DEDUCTION = 'Payroll or Pension Deduction',
  SEND_BILL_TO = 'Send Bill To'
}

export const billingMethodsEnrolledInAutoPay: string[] = [
  billingMethods.AUTOMATIC_PAYMENT_PLAN,
  billingMethods.AUTOMATIC_PAYMENT_PLAN_BANK_ACCOUNT,
  billingMethods.AUTOMATIC_PAYMENT_PLAN_CREDIT_CARD
];

export enum billingPolicyLineOfBusiness {
  AUTO = 'Auto',
  DWELLING_FIRE = 'Dwelling Fire',
  HOME = 'Home',
  HOME_FIRE = 'Home/Fire',
  LIFE = 'Life',
  OCEAN_MARINE = 'Ocean Marine',
  INLAND_MARINE = 'Inland Marine',
  PERSONAL_UMBRELLA_POLICY = 'Personal Umbrella Policy'
}

export enum billingLifePolicyType {
  ANNUITY = 'Annuity',
  SUPPLIMENTARY = 'Supplimentary',
  STRUCTURED_SETTLEMENT = 'Settlement Agreements',
  LIFE = 'Life'
}

export enum billingPolicyTypes {
  ENROLLED_IN_AUTOPAY = 'autoPayEnrolled',
  ELIGIBLE_FOR_AUTOPAY = 'autoPayEligible'
}

export enum billingPolicyStatuses {
  CANCELLATION = 'cancellation',
  PAST_DUE = 'pastDue',
  CURRENT = 'current'
}

export enum billingPolicyCoverageStatuses {
  ACTIVE = 'Active',
  RENEWAL = 'Renewal',
  NEW = 'New',
  SCHEDULED = 'Scheduled',
  PENDING = 'Pending',
  EXPIRED = 'Expired',
  CANCELLED = 'Cancelled'
}

export enum paymentSteps {
  PAY_POLICIES = 'paypolicies',
  SINGLE_PAY = 'singlepay',
  PAYMENT_MODAL = 'paymentmodal'
}

export enum mutualBillingPlan {
  QUARTERLY = 'Quarterly',
  MONTHLY = 'Monthly',
  FULL_PAY = 'Full Pay',
  TEN_PAY = '10-Pay',
  ANNUAL = 'Annual',
  SEMI_ANNUAL = 'Semiannual'
}

export enum billingFrequency {
  MONTHLY = 'Monthly',
  ANNUAL = 'Annual',
  BIWEEKLY = 'Biweekly',
  QUARTERLY = 'Quarterly',
  SEMI_ANNUALLY = 'Semi-Annual',
  SPECIAL_MONTHLY = 'Special Monthly'
}

export enum billingPaymentPolicyType {
  NONE = 'none',
  MUTUAL = 'mutual',
  LIFE = 'life',
  ANNUITY = 'annuity'
}

export enum billingTypes {
  DIRECT_BILL,
  AUTOPAY
}

export enum paymentStatus {
  OK = 'ok',
  PENDING = 'pending'
}

export enum currency {
  ZERO_CURRENCY = '$0.00',
  ZERO_CURRENCY_LEADING_ZERO = '$00.00'
}

export enum targetOperation {
  MAKE_PAYMENT = 'makePayment',
  AUTOPAY = 'enrollAutoPay',
  MANAGE_PAYMENT_METHODS = 'managePaymentMethods'
}

export enum divisionType {
  MUTUAL = 'mutual',
  LIFE = 'life'
}

export enum accountGroupCodeType {
  MUTUAL = 'Amica Mutual',
  LIFE = 'Amica Life'
}

export enum paymentCategory {
  USER_SELECT = 'UserSelect',
  BANK_ACCOUNT = 'ECheck',
  CREDIT_CARD = 'CreditCard'
}

export enum paymentSource {
  PRE_LOGIN = 'ExpressPayment',
  POST_LOGIN = 'AmicaWeb',
  MOBILE_APP = 'AmicaMobile'
}

export enum feeContext {
  NO_FEE = 'PaymentWithoutFee'
}

export enum amountContext {
  AMOUNT_DUE_ONLY = 'AmountDueOnly'
}

export enum billingMethodSaveOption {
  USER_SELECT = 'UserSelect'
}

export enum modalEvent {
  LOAD = 'portalOne.load',
  UNLOAD = 'portalOne.unload',
  ERROR = 'portalOne.error',
  PAYMENT_COMPLETE = 'portalOne.paymentComplete',
  PAYMENT_CANCELED = 'portalOne.paymentCanceled',
  SCHEDULED_PAYMENT_CREATED = 'portalOne.scheduledPaymentCreated',
  MODAL_DIALOG_OPENED = 'portalOne.modalDialogOpened',
  PAYMENT_METHOD_SAVE_COMPLETE = 'portalOne.saveComplete',
  ENROLL_AUTOPAY_COMPLETE = 'portalOne.enrollAutoPayComplete',
  ENROLL_AUTOPAY_CANCELED = 'portalOne.enrollAutoPayCanceled',
  UPDATE_AUTOPAY_COMPLETE = 'portalOne.updateAutoPayComplete',
  UPDATE_AUTOPAY_CANCELED = 'portalOne.updateAutoPayCanceled',
  STOP_AUTOPAY_COMPLETE = 'portalOne.stopAutoPayComplete'
}

const defaultEditAutoPayWithdrawalDates = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
];

//One Inc defaulted values
export const autoPayDefaultValues = {
  amount: 1,
  numberOfInstallments: 12,
  editWithdrawalDate: defaultEditAutoPayWithdrawalDates,
  enrollWithdrawalDate: [1],
  withdrawalFrequency: 'Monthly'
};

export enum oneIncFrequencyEnum {
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  SEMI_ANNUALLY = 'Semiannually',
  ANNUALLY = 'Annually'
}

export enum FlowEnum {
  SINGLE_PAY = 'Make a Payment - Pay Single - ',
  PAY_ALL = 'Make a Payment - Pay All - ',
  QUICK_PAY = 'Make a Payment - Quick Pay - ',
  CHANGE_PAYMENT_PLAN = 'Make a Payment - Change Payment Plan -',
  AUTOPAY_ENROLL = 'Billing - Enroll AutoPay - ',
  AUTOPAY_UPDATE = 'Billing - Update AutoPay - ',
  AUTOPAY_UNENROLL = 'Billing - Unenroll AutoPay - ',
  MANAGE_PAYMENTS = 'Manage Payments - ',
  EXPRESS_PAY = 'Express Payment - ',
  ONBOARDING_DOWNPAYMENT = 'Onboarding - Downpayment - ',
  ONBOARDING_AUTOPAY = 'Onboarding - AutoPay - '
}
